import React from 'react';
import { message } from 'antd';

const formatDate = (d) => {
    const y = Math.floor(d / 10000);
    const m = Math.floor((d % 10000) / 100);
    const day = d % 100;
    return `${m}月${day}日`;
};

/**
 * 可补签日期列表
 */
const CheckinMakeupList = React.memo(({ canMakeupDates = [], makeupLeft, makeupCoinCost, coinRemain, loading, onMakeup }) => {
    if (makeupLeft <= 0 || canMakeupDates.length === 0) return null;
    const canAfford = coinRemain >= makeupCoinCost;

    const handleClick = (date) => {
        if (!canAfford) {
            message.warning(`金币不足，补签需要 ${makeupCoinCost} 金币`);
            return;
        }
        if (loading) return;
        onMakeup(date);
    };

    return (
        <div className="checkin-makeup">
            <div className="checkin-makeup-title">
                补签（本月剩余 {makeupLeft} 次，每次 {makeupCoinCost} 金币）
            </div>
            <div className="checkin-makeup-list">
                {canMakeupDates.map((date) => (
                    <button
                        key={date}
                        type="button"
                        className="checkin-makeup-item"
                        disabled={loading}
                        onClick={() => handleClick(date)}
                    >
                        {formatDate(date)}
                    </button>
                ))}
            </div>
        </div>
    );
});

export default CheckinMakeupList;
